export enum ChangesState {
    noChange,
    added,
    deleted,
    changed,
    moved
}